import React, { useEffect, useState } from 'react';
import { Dayjs } from '../../logic/classDayjs';
import { FORMAT_DATE_M, FORMAT_DATE_D } from '../../constants/const';

interface pitProps {
  dayLength: number;
  dayCount: number[];
  directionY: String;
  dayStr: string[];
  monthIndex: number;
}

interface dayProp {
  month: number;
  day: number;
  view: string;
}

const months: number[] = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
const WEEK_DAYS = ['日', '月', '火', '水', '木', '金', '土'];

const MultiDateMarkers: React.FC<pitProps> = (pitProps) => {
  const BURN_GRAPH_WIDTH: number = 875;
  const GRAPH_OFFSET: number = 875;
  const YEAR_INTERVAL_OFFSET: number = 2;
  const MONTH_INTERVAL_OFFSET: number = 0;
  const LEFT_POSI_OFFSET: number = 6;

  const [resultEmptyCheckState, setResultEmptyCheckState] = useState<string[]>([]);
  const [dayWidth, setDayWidth] = useState<number>();

  useEffect(() => {
    const dayProps: dayProp[] = [];

    for (let i = 0; i < pitProps.dayStr.length; i++) {
      const date = new Date(pitProps.dayStr[i]);
      const retDay: dayProp = {
        month: Number(Dayjs.convertStr(date, FORMAT_DATE_M)),
        day: Number(Dayjs.convertStr(date, FORMAT_DATE_D)),
        view: `${date.getMonth() + 1}/${date.getDate()}(${WEEK_DAYS[date.getDay()]})`,
      };
      if (pitProps.monthIndex === 0) {
        dayProps.push(retDay);
      } else if (months[pitProps.monthIndex - 1] === retDay.month) {
        dayProps.push(retDay);
      }
    }
    const labelStr: string[] = [];

    let count = 0;
    if (pitProps.monthIndex === 0) {
      for (let i = 0; i < pitProps.dayCount.length; i++) {
        for (let j = 0; j < pitProps.dayCount[i]; j++) {
          if (dayProps.length > count) {
            if (dayProps[count].month === months[i] && dayProps[count].day === j + 1) {
              labelStr.push((pitProps.directionY === 'Top' ? '↓' : '↑').concat(dayProps[count].view));
              count = count + 1;
            } else {
              labelStr.push('');
            }
          } else {
            labelStr.push('');
          }
        }
      }
    } else {
      for (let j = 0; j < pitProps.dayCount[pitProps.monthIndex - 1]; j++) {
        if (dayProps.length > count) {
          if (dayProps[count].day === j + 1) {
            labelStr.push((pitProps.directionY === 'Top' ? '↓' : '↑').concat(dayProps[count].view));
            count = count + 1;
          } else {
            labelStr.push('');
          }
        } else {
          labelStr.push('');
        }
      }
    }
    setResultEmptyCheckState(labelStr);
    setDayWidth((BURN_GRAPH_WIDTH - (pitProps.monthIndex === 0 ? YEAR_INTERVAL_OFFSET : MONTH_INTERVAL_OFFSET)) / pitProps.dayLength);
  }, [pitProps.dayCount, pitProps.directionY, pitProps.dayStr, pitProps.monthIndex, pitProps.dayLength]);

  return (
    <div
      style={{
        position: 'relative',
        width: BURN_GRAPH_WIDTH + GRAPH_OFFSET,
        height: 30,
        background: 'transparent',
        userSelect: 'none',
      }}
    >
      {Array.from({
        length: resultEmptyCheckState.length,
      }).map((_, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            left: dayWidth ? index * dayWidth - LEFT_POSI_OFFSET : 0,
            textAlign: 'center',
            fontSize: 14,
          }}
        >
          {/* 矢印と日付 */}
          <div>{resultEmptyCheckState[index]}</div>
        </div>
      ))}
    </div>
  );
};

export default MultiDateMarkers;
